import { createReducer } from 'helpers/ReducerUtil'
import * as R from 'ramda'

import {
  ADD_VALIDATION_CHECK,
  REMOVE_VALIDATION_CHECK,
  CLEAR_VALIDATION,
  REGISTER_ELEMENT,
} from './constants'

const clearValidation = () => ({})
const removeValidationCheck = (validations, { id }) => ({ ...validations, [id]: true })
const addValidationCheck = (validations, { id }) => ({ ...validations, [id]: false })
const registerElement = (validations, { id }) => ({ ...validations, [id]: true })

export default createReducer({}, {
  [CLEAR_VALIDATION]: clearValidation,
  [ADD_VALIDATION_CHECK]: addValidationCheck,
  [REMOVE_VALIDATION_CHECK]: removeValidationCheck,
  [REGISTER_ELEMENT]: registerElement,
})
